import * as React from 'react';
import { withRouter } from 'react-router';

import { UniversalContext, Redirect } from '../../_universal';
import { buildLoginUrl } from '../utils/urls';

function Unauthorized(props) {
  const universalContext = React.useContext(UniversalContext);

  const { children, history } = props;
  const { location } = history;
  const next = `${location.pathname}${location.search}`;
  universalContext.trackEvent({
    onServer: true,
    event: 'Unauthorized Access',
    properties: { next },
  });
  const loginUrl = buildLoginUrl({ reason: 'unauthorized', next });
  return (
    <Redirect to={loginUrl} fullNavigation>
      {children}
    </Redirect>
  );
}

export default withRouter(Unauthorized);
